var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08341 4.16667V3.33333C7.08341 2.18274 6.15067 1.25 5.00008 1.25C3.84949 1.25 2.91675 2.18274 2.91675 3.33333V4.16667M5.00008 6.04167V6.875M3.66675 8.75H6.33341C7.03348 8.75 7.38351 8.75 7.6509 8.61376C7.88611 8.49392 8.07733 8.30269 8.19717 8.06749C8.33341 7.8001 8.33341 7.45007 8.33341 6.75V6.16667C8.33341 5.4666 8.33341 5.11657 8.19717 4.84918C8.07733 4.61398 7.88611 4.42275 7.6509 4.30291C7.38351 4.16667 7.03348 4.16667 6.33341 4.16667H3.66675C2.96668 4.16667 2.61665 4.16667 2.34926 4.30291C2.11406 4.42275 1.92283 4.61398 1.80299 4.84918C1.66675 5.11657 1.66675 5.4666 1.66675 6.16667V6.75C1.66675 7.45007 1.66675 7.8001 1.80299 8.06749C1.92283 8.30269 2.11406 8.49392 2.34926 8.61376C2.61665 8.75 2.96668 8.75 3.66675 8.75Z",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLock);
export default __webpack_public_path__ + "static/media/whiteLock.d38f299bc1f1f9727155cb0aeb9afa92.svg";
export { ForwardRef as ReactComponent };